import { FormFields } from './FormFields';
import { TransactionSteps } from './TransactionSteps';
export const PlaceOffer = () => {
  return (
    <div className=''>
      <div className='bg-f-bk mx-6 h-40 flex justify-center items-center'>
        <h2 className='font-semibold text-xl pb-6 text-p-bk'>
          Place a Buy/Sell FX Offer
        </h2>
      </div>
      <div className='w-full flex flex-col gap-16 px-6 py-8 relative border-f-bk mx-auto mt-8'>
        <div className=''>
          <h2 className='font-semibold text-lg pb-6'>
            Steps To Completing Transations
          </h2>
          <TransactionSteps />
        </div>
        <div className=''>
          <h2 className='font-semibold text-lg pb-6'>Place Offer Form</h2>
          <FormFields />
        </div>
      </div>
    </div>
  );
};
